<template>
  <div class="card" v-bind:key="card.flipped">
    <img  v-bind:src="card.flipped ? card.image : 'assets/images/cardback.svg'" height="160px" width="180px"/>
    <p v-show="card.flipped">{{card.name}}</p>
  </div>
</template>

<script>
    export default {
      name: "app-matching-card",
      props: {
        card: {
          type: Object
        }
      }
    }
</script>

<style scoped>
  ul {
    padding-left: 0;
    display: flex;
    flex-flow: row wrap;
  }

  li {
    list-style-type: none;
    padding: 10px 10px;
    transition: all 0.3s ease;
  }

  .card {
    display: block;
    width: 230px;
    height: 230px;
    padding-top: 35px;
    border-radius: 7px;
    text-align: center;
    line-height: 27px;
    cursor: pointer;
    position: relative;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    -webkit-box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    -moz-box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    will-change: transform;
  }

  li:hover{
    transform: scale(1.1);
  }

  li .card{
    background-color: #302f30;
  }

  .flip-enter-active {
    transition: all 0.4s ease;
  }

  .flip-leave-active {
    display: none;
  }

  .flip-enter, .flip-leave {
    transform: rotateY(180deg);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/app-matching-card.vue